import React, {
  createContext,
  type FC,
  type PropsWithChildren,
  useState,
} from 'react'

type Props = {
  isVisible: boolean
  setIsVisible: ((state: boolean) => void) | (() => void)
}

export const CtaVisibleContext = createContext<Props>({
  isVisible: true,
  setIsVisible() {
    console.error('You forgot to put the Cta Visible provider')
  },
})

export const CtaHiddenProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isHeroCtaVisible, setIsHeroCtaVisible] = useState(true)

  return (
    <CtaVisibleContext.Provider
      value={{
        isVisible: isHeroCtaVisible,
        setIsVisible: setIsHeroCtaVisible,
      }}
    >
      {children}
    </CtaVisibleContext.Provider>
  )
}
